import { assert } from '../..';
import { withValidation } from '../../validations';
const ariaValueTextSDKFactory = ({ setProps, props }) => ({
    get valueText() {
        return props.ariaAttributes?.valueText;
    },
    set valueText(value) {
        setProps({
            ariaAttributes: {
                ...props.ariaAttributes,
                valueText: assert.isNil(value) ? undefined : String(value),
            },
        });
    },
});
export const createAriaValueTextSDK = withValidation(ariaValueTextSDKFactory, {
    type: ['object'],
    properties: {
        valueText: {
            type: ['string'],
            minLength: 1,
            maxLength: 1000,
        },
    },
});
//# sourceMappingURL=ariaValueTextSDKFactory.js.map